/**
 * Last-successful-login email persistence (P6.2c).
 *
 * Single owner of the `hgs-admin:last-login-email` localStorage key.
 * Until this module landed, the key was hard-coded in three places
 * (`Login.tsx` read + write + test-setup reset); a typo on any one of
 * them silently broke the autofill flow while the other two looked
 * fine. CLAUDE.md §1 (no magic-string contracts) forbids the pattern.
 *
 * All three helpers wrap `localStorage` access in `try/catch` because
 * the Login page renders in environments where storage is unavailable
 * (incognito profiles, JSDOM tests with no `localStorage` shim, etc.);
 * a thrown read should never block rendering the empty state.
 */

const KEY = 'hgs-admin:last-login-email';

export function getLastLoginEmail(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setLastLoginEmail(email: string): void {
  try {
    localStorage.setItem(KEY, email);
  } catch {
    /* best-effort */
  }
}

export function clearLastLoginEmail(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* best-effort */
  }
}
